import { createPopper } from '@popperjs/core';

document.addEventListener('DOMContentLoaded', () => {
    const triggers = [
        {event: 'mouseover', checker: isHoverable, fn: show},
        {event: 'mouseout', checker: isHoverable, fn: hide},
        {event: 'click', checker: isClickable, fn: show},
        {event: 'focusout', checker: isClickable, fn: hide},
        {event: 'focus', checker: () => true, fn: show},
        {event: 'blur', checker: () => true, fn: hide},
    ];

    triggers.forEach(({event, checker, fn}) => {
        document.addEventListener(event, e => {
            const tooltipToggleEl = e.target.closest('[data-tooltip-target]')

            if (tooltipToggleEl && checker(tooltipToggleEl)) {
                runTooltip(tooltipToggleEl, fn);
            }
        }, false);
    })

    function runTooltip(tooltipToggleEl, fn) {
        const tooltipEl = document.getElementById(tooltipToggleEl.getAttribute('data-tooltip-target'));
        const placement = tooltipToggleEl.getAttribute('data-tooltip-placement');

        const popperInstance = createPopper(tooltipToggleEl, tooltipEl, {
            placement: placement ? placement : 'top',
            modifiers: [
                {
                    name: 'offset',
                    options: {
                        offset: [0, 6],
                    },
                },
            ],
        });

        fn(tooltipEl, popperInstance);
    }

    function show(tooltipEl, popperInstance) {
        // Make the tooltip visible
        tooltipEl.classList.remove('opacity-0');
        tooltipEl.classList.add('opacity-100');
        tooltipEl.classList.remove('invisible');
        tooltipEl.classList.add('visible');

        // Enable the event listeners
        popperInstance.setOptions((options) => ({
            ...options,
            modifiers: [
                ...options.modifiers,
                { name: 'eventListeners', enabled: true },
            ],
        }));

        // Update its position
        popperInstance.update();
    }

    function hide(tooltipEl, popperInstance) {
        // Hide the tooltip
        tooltipEl.classList.remove('opacity-100');
        tooltipEl.classList.add('opacity-0');
        tooltipEl.classList.remove('visible');
        tooltipEl.classList.add('invisible');

        // Disable the event listeners
        popperInstance.setOptions((options) => ({
            ...options,
            modifiers: [
                ...options.modifiers,
                { name: 'eventListeners', enabled: false },
            ],
        }));
    }

    function isHoverable(tooltipToggleEl) {
        const trigger = tooltipToggleEl.getAttribute('data-tooltip-trigger');
        return !trigger || trigger === 'hover';
    }

    function isClickable(tooltipToggleEl) {
        return tooltipToggleEl.getAttribute('data-tooltip-trigger') === 'click';
    }
});
